<template>
  <router-link class="ref-video-card" :class="{ 'ref-video-card--horizontal': horizontal }"
    :to="{ path: '/PlayVideo', query: { id: item.id || item.vod_id } }">
    <div class="ref-video-card__cover">
      <img v-if="cover && !broken" :src="cover" :alt="item.vod_name || item.name || $t('frontend.video.cover')" loading="lazy" @error="broken = true">
      <van-icon v-else name="video-o" class="ref-video-card__placeholder" />
      <span class="ref-video-card__play"><van-icon name="play" /></span>
      <span v-if="item.duration || item.vod_duration" class="ref-video-card__duration">{{ item.duration || item.vod_duration }}</span>
    </div>
    <div class="ref-video-card__body">
      <h3>{{ item.vod_name || item.name || $t('frontend.video.untitled') }}</h3>
      <p><van-icon name="play-circle-o" /> {{ $t('frontend.video.play_count', { count }) }}</p>
      <span v-if="horizontal" class="ref-video-card__tag">{{ $t('frontend.home.hot') }}</span>
    </div>
  </router-link>
</template>
<script>
import { imageUrl, displayNumber } from "./reference";
export default {
  props: { item: { type: Object, required: true }, horizontal: Boolean },
  data: () => ({ broken: false }),
  computed: {
    cover() { return imageUrl(this.item.vod_pic || this.item.cover || this.item.img); },
    count() { return displayNumber(this.item.count || this.item.vod_hits || 0); }
  },
  watch: { cover() { this.broken = false; } }
};
</script>
